<template>
  <div class="d-flex" id="wrapper">
    <Sidebar :toggler.sync="isToggled" />
    <!-- Page Content -->

    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getUserProfile" />
      <div v-if="isMainLoading" class="container-fluid mobile-settings">
        <div class="col-md-12">
          <div class="card card-custom" style="height: 85vh !important;">
            <Spinner :isLoading="isMainLoading" />
          </div>
        </div>
      </div>
      <div v-else class="container-fluid mobile-settings">
        <div class="row d-flex justify-content-center">
          <div class="col-md-6">
            <div class="card card-custom">
              <div class="graphs-container">
                <ChartOne />
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div id="cardu" class="card card-custom">
              <div class="graphs-container">
                <div ref="funnel1" id="funnel-chart1">
                  <FunnelOne />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="card card-custom" style="margin-right: 0">
              <div class="graphs-container">
                <ChartTwo />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div id="cardu2" class="card card-custom" style="margin-left: 0">
              <div class="graphs-container">
                <div ref="funnel2" id="funnel-chart2">
                  <FunnelTwo />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row hide-on-mobile">
          <div class="col-md-12">
            <div class="card" style="margin: 0 0 30px 0">
              <h6 class="p-3" style="font-weight: 700; display:flex;margin-bottom:0">
                Placements
                <span class="ml-auto"
                  ><img
                    @click="type = 'recentplacements'"
                    v-if="getAccType === 'admin'"
                    data-toggle="modal"
                    href="#addUserModalUserManagment"
                    type="button"
                    title="Download Excel document"
                    style="cursor:pointer"
                    width="30"
                    height="30"
                    src="https://jobshark.eu/img/doc-types/Excel.png"
                    alt="download table"
                /></span>
              </h6>
              <div class="table-responsive">
                <table class="table table-striped custom-table">
                  <thead class="bg-dark">
                    <tr>
                      <th class="sticky" nowrap scope="col">NAME</th>
                      <th nowrap scope="col">JOB</th>
                      <th nowrap scope="col">EMPLOYER</th>
                      <th nowrap scope="col">LOCATION</th>
                      <th nowrap cpope="col">HIRED</th>
                      <th nowrap cpope="col">SOURCE</th>
                    </tr>
                  </thead>

                  <tbody>
                    <DashboardRecentPlacementsTableItem
                      v-for="(rPlacement, i) in getRecentPlacements"
                      :recentPlacement="rPlacement"
                      :key="i"
                    />
                  </tbody>
                </table>
              </div>
              <div class="bottom-controls ml-auto mt-auto w-10">
                <div id="pagination" class="desktop-only">
                  <Pagination
                    :currentPage="getCurrentPage"
                    :totalPages="getTotalPages"
                    @nextPage="nextPage"
                    @prevPage="previousPage"
                    @keyup="keymonitor"
                    @selectPageByNumber="setPageBynumber"
                    @firstPage="setToFirstPage"
                    @lastPage="setToLastPage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row hide-on-mobile">
          <div class="col-md-12">
            <div class="card" style="margin: 0 0 30px 0">
              <h6 class="p-3" style="font-weight: 700; display:flex;margin-bottom:0">
                Submitted
                <span class="ml-auto"
                  ><img
                    @click="type = 'headhunted'"
                    v-if="getAccType === 'admin'"
                    data-toggle="modal"
                    href="#addUserModalUserManagment"
                    type="button"
                    title="Download Excel document"
                    style="cursor:pointer"
                    width="30"
                    height="30"
                    src="https://jobshark.eu/img/doc-types/Excel.png"
                    alt="download table"
                /></span>
              </h6>
              <div class="table-responsive">
                <table class="table table-striped custom-table">
                  <thead class="bg-dark">
                    <tr>
                      <th class="sticky" nowrap scope="col">NAME</th>
                      <th nowrap scope="col">JOB</th>
                      <th nowrap scope="col">EMPLOYER</th>
                      <th nowrap scope="col">LOCATION</th>
                      <th nowrap cpope="col">Submitted</th>
                      <th nowrap cpope="col">SOURCE</th>
                    </tr>
                  </thead>

                  <tbody>
                    <DashboardHeadHuntedItem
                      v-for="(headhunted, index) in headHunted"
                      :recentPlacement="headhunted"
                      :key="index"
                    />
                  </tbody>
                </table>
              </div>
              <div class="bottom-controls ml-auto mt-auto w-10">
                <div id="pagination" class="desktop-only">
                  <Pagination
                    :currentPage="headPage"
                    :totalPages="headTotalPages"
                    @nextPage="nextPageHead"
                    @prevPage="previousPageHead"
                    @keyup="keymonitorHead"
                    @selectPageByNumber="setPageBynumberHead"
                    @firstPage="setToFirstPageHead"
                    @lastPage="setToLastPageHead"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- mobile lists replace tables on mobie device -->
          <div class="mobile-lists">
            <h6>Recent Placements</h6>
            <ul class="list-unstyled">
              <li>
                <div class="d-flex align-items-center">
                  <a class="user" href="#">Stefan Dimitrov</a>
                  <a class="company ml-auto" href="#">Comstream</a>
                </div>
                <div class="d-flex align-items-center">
                  <span class="location">Stockholm, Sweden</span>
                  <a class="job-position ml-auto" href="#">Java Developer</a>
                </div>
                <div class="d-flex align-items-center mt-2">
                  <span class="date">10:05:2020</span>
                  <span class="ml-auto rec">Recruiter: DD</span>
                </div>
              </li>
              <li>
                <div class="d-flex align-items-center">
                  <a class="user" href="#">Stefan Dimitrov</a>
                  <a class="company ml-auto" href="#">Comstream</a>
                </div>
                <div class="d-flex align-items-center">
                  <span class="location">Stockholm, Sweden</span>
                  <a class="job-position ml-auto" href="#">Java Developer</a>
                </div>
                <div class="d-flex align-items-center mt-2">
                  <span class="date">10:05:2020</span>
                  <span class="ml-auto rec">Recruiter: DD</span>
                </div>
              </li>
              <li>
                <div class="d-flex align-items-center">
                  <a class="user" href="#">Stefan Dimitrov</a>
                  <a class="company ml-auto" href="#">Comstream</a>
                </div>
                <div class="d-flex align-items-center">
                  <span class="location">Stockholm, Sweden</span>
                  <a class="job-position ml-auto" href="#">Java Developer</a>
                </div>
                <div class="d-flex align-items-center mt-2">
                  <span class="date">10:05:2020</span>
                  <span class="ml-auto rec">Recruiter: DD</span>
                </div>
              </li>
              <li>
                <div class="d-flex align-items-center">
                  <a class="user" href="#">Stefan Dimitrov</a>
                  <a class="company ml-auto" href="#">Comstream</a>
                </div>
                <div class="d-flex align-items-center">
                  <span class="location">Stockholm, Sweden</span>
                  <a class="job-position ml-auto" href="#">Java Developer</a>
                </div>
                <div class="d-flex align-items-center mt-2">
                  <span class="date">10:05:2020</span>
                  <span class="ml-auto rec">Recruiter: DD</span>
                </div>
              </li>
            </ul>
          </div>
          <!-- End mobile lists replace tables on mobie device -->
        </div>
      </div>
      <!-- Welcome Modal -->
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Welcome to JobShark</h5>
            </div>
            <div class="modal-body">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
              dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            </div>
            <div class="modal-footer d-flex justify-content-center">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Continue</button>
              <button type="button" class="btn btn-primary" data-dismiss="modal">Skip Tour</button>
            </div>
          </div>
        </div>
      </div>
      <!-- End Welcome Modal -->
    </div>
    <!-- End page-content-wrapper -->
    <div
      class="modal fade add-user-modal"
      id="addUserModalUserManagment"
      tabindex="-1"
      aria-labelledby="addUserModalUserManagment"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title mb-3" id="addUserModalUserManagment">
              Statistics - {{ type === 'recentplacements' ? 'Placements' : 'Submitted' }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeDownload"
              @click="resetDates"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div class="d-flex w-100">
              <div class="form-group  m-label-left" style="width:80%; margin-right:5px">
                <input
                  id="start-date"
                  type="date"
                  class="form-control"
                  v-model="startDate"
                  :max="endDate"
                />
                <label for="start-date">Start date</label>
              </div>
              <div class="form-group  m-label-left" style="width:80%; margin-left:5px">
                <input
                  id="end-date"
                  type="date"
                  :min="startDate"
                  class="form-control"
                  v-model="endDate"
                />
                <label for="end-date">End date</label>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="downloadTable(type)" type="button" class="btn btn-primary">
              Generate
            </button>

            <button
              type="button"
              @click="resetDates"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Sidebar from '@/components/Navigations/Sidebar';
import TopNavbar from '@/components/Navigations/TopNavbar';
/* import FunnelDiagram from '@/components/Admin/Dashboard/FunnelDiagram'; */
import DashboardRecentPlacementsTableItem from '../../components/Admin/Dashboard/DashboardRecentPlacementsTableItem';
import DashboardHeadHuntedItem from '../../components/Admin/Dashboard/DashboardHeadHuntedItem';
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';
import Pagination from '@/components/Navigations/Pagination';

import ChartOne from '@/components/Admin/Dashboard/LineChart/ChartOne';
import ChartTwo from '@/components/Admin/Dashboard/LineChart/ChartTwo';
import FunnelOne from '@/components/Admin/Dashboard/FunnelChart/FunnelOne';
import FunnelTwo from '@/components/Admin/Dashboard/FunnelChart/FunnelTwo';

import axios from 'axios';
import format from 'date-fns/format';
import moment from 'moment';
// import { errorService } from '../../services/errorService';+
import titleMixin from '../../mixins/titleMixin';

export default {
  components: {
    Sidebar,
    TopNavbar,
    ChartOne,
    ChartTwo,
    FunnelOne,
    FunnelTwo,
    Pagination,
    DashboardRecentPlacementsTableItem,
    DashboardHeadHuntedItem,
  },
  mixins: [toggleSidebarNav, titleMixin],
  title() {
    return 'Dashboard | Jobshark';
  },
  data: () => ({
    headHunted: [],
    type: 'recentplacements',
    listOfSelectedJobs: [],
    isMainLoading: true,
    elWidth: null,
    filterCurrentSelection: 'All time',
    isToggled: false,
    isLoading: false,
    dateFormat: 'D MMM YYYY',
    startDate: '',
    endDate: '',
    currentPage: 1,
    pageCount: 10,
    startDate: '',
    endDate: '',
    headPage: 1,
    headTotalPages: '',
    today: '',
  }),
  methods: {
    ...mapActions([
      'retrieveEmployersDropdown',
      'retrieveUserProfile',
      'retrieveJobsForEmployerChart',
      'retrieveCharOnetData',
      'retrieveSourcesList',
      'retrieveFunnelOneData',
      'retrieveRecentPlacements',
      'retrieveHeadhunted',
    ]),

    downloadTable(type) {
      let fileName = '';
      if (this.startDate.length === 0 || this.endDate.length === 0) {
        this.$toasted.error('Please select time range first.', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        return false;
      }
      if (type === 'recentplacements') {
        fileName = 'statistics_placements.xlsx';
      } else {
        fileName = 'statistics_submitted.xlsx';
      }
      axios(`${process.env.VUE_APP_API_URL}/admin/exports/${type}`, {
        method: 'post',
        data: {
          start_date: this.startDate,
          end_date: this.endDate,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        responseType: 'arraybuffer',
      })
        .then(res => {
          const blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          this.$refs.closeDownload.click();
          this.resetDates();
        })
        .catch(err => {
          this.$toasted.error('There was an error communicating with the server.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    resetDates() {
      this.startDate = '';
      this.type = 'recentplacements';
      this.defaultDate();
    },

    defaultDate() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, '0');
      let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      let yyyy = today.getFullYear();
      this.endDate = yyyy + '-' + mm + '-' + dd;
      today.setDate(1);
      this.startDate = today.toISOString().slice(0, 10);
    },

    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        this.previousPage();
      }
    },

    lastSevenDays() {
      return `${moment().format('DD MMM YYYY')} - ${moment()
        .add(7, 'days')
        .format('DD MMM YYYY')}`;
    },
    lastThirtyDays() {
      return `${moment().format('DD MMM YYYY')} - ${moment()
        .add(30, 'days')
        .format('DD MMM YYYY')}`;
    },
    lastNinetyDays() {
      return `${moment().format('DD MMM YYYY')} - ${moment()
        .add(90, 'days')
        .format('DD MMM YYYY')}`;
    },
    handleFilter(e) {
      if (e.target.innerText === 'Last 7 days') {
        this.filterCurrentSelection = this.lastSevenDays();
      }

      if (e.target.innerText === 'Last 30 days') {
        this.filterCurrentSelection = this.lastThirtyDays();
      }

      if (e.target.innerText === 'Last 90 days') {
        this.filterCurrentSelection = this.lastNinetyDays();
      }

      if (e.target.innerText === 'All time') {
        this.filterCurrentSelection = 'All time';
      }
    },
    formatDates(startDate, endDate) {
      /*  if (startDate) {
        formattedDates = format(startDate, this.dateFormat);
      }

      if (endDate) {
        formattedDates += ' - ' + format(endDate, this.dateFormat);
      } */

      if (startDate && endDate) {
        return `${format(startDate, this.dateFormat)} - ${format(endDate, this.dateFormat)}`;
      }
    },

    /* PAGINATION */
    nextPage() {
      if (this.currentPage >= 1 && this.currentPage < this.getTotalPages) {
        this.isLoading = true;
        this.currentPage++;

        this.retrieveRecentPlacements({
          page: this.currentPage,
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        this.retrieveRecentPlacements({
          page: this.currentPage,
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        this.currentPage = 1;
      }
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      this.retrieveRecentPlacements({
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      this.retrieveRecentPlacements({
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    setPageBynumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.currentPage = pageNumber;

      this.retrieveRecentPlacements({
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    /* END PAGINATION */

    /* Head HUnted PAGINATION */
    nextPageHead() {
      if (this.headPage >= 1 && this.headPage < this.headTotalPages) {
        this.isLoading = true;
        this.headPage++;
        this.getHeadHunted(this.headPage);
      }
    },
    previousPageHead() {
      if (this.headPage > 1) {
        this.isLoading = true;
        --this.headPage;

        this.getHeadHunted(this.headPage);
      } else {
        this.headPage = 1;
      }
    },
    setToFirstPageHead() {
      this.isLoading = true;
      this.headPage = 1;

      this.getHeadHunted(this.headPage);
    },
    setToLastPageHead(lastPage) {
      this.isLoading = true;
      this.headPage = this.headTotalPages;

      this.getHeadHunted(this.headPage);
    },
    setPageBynumberHead(pageNumber) {
      if (pageNumber > this.headTotalPages || this.headPage < 1) return;
      this.headPage = pageNumber;

      this.getHeadHunted(this.headPage);
    },
    /* END Head HUnted PAGINATION */

    getHeadHunted(page) {
      axios(`${process.env.VUE_APP_API_URL}/admin/dashboard/headhunted`, {
        method: 'get',
        params: {
          page: page,
          count: 10,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(res => {
          this.headHunted = res.data.data;
          this.headTotalPages = res.data.last_page;
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
  },
  computed: {
    ...mapGetters([
      'getEmployersDropdown',
      'getAccType',
      'getUserProfile',
      'getChartOneData',
      'getNextPage',
      'getTotalPages',
      'getCurrentPage',
      'getRecentPlacements',
      'getRecentHeadHunted',
    ]),
    myStyles() {
      return {
        height: `${100}%`,
        width: `${100}%`,
        position: 'absolute',
      };
    },
  },

  mounted() {
    this.defaultDate();
    this.getHeadHunted(this.headPage);
    this.retrieveRecentPlacements({
      page: 1,
      count: 10,
    });

    this.retrieveEmployersDropdown().then(() => {
      this.isMainLoading = false;
    });
    this.retrieveUserProfile();
    this.retrieveSourcesList();
    /* this.thefunnelHeight = Math.abs(this.$refs.funnel1.clientHeight - 100);
    this.theFunnelWidth = this.$refs.funnel1.clientWidth; */
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.graphs-container {
  display: flex;
  position: relative;
  flex: 1;
}

#funnel-chart1,
#funnel-chart2 {
  display: flex;
  flex: 1;
}

.graphs,
#wrapper {
  overflow: hidden;
  .card-custom {
    display: flex;
    margin: 0 0 30px 0 !important;
    height: 420px;
  }
  .row {
    padding-left: 9px;
    padding-right: 9px;
  }
}

.svg-funnel-js {
}
.svg-funnel-js__subLabels {
  margin-top: 200px !important;
}
.graphs {
  font-family: $font-family-sans-lato !important;
}

/deep/ .svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__title {
  font-size: 13px;
  font-weight: normal;
  color: #333;
  /*   background: #e65023; */
  font-family: $font-family-sans-lato !important;
}

/deep/ .svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__value {
  font-size: 13px;

  line-height: 18px;
  margin-bottom: 6px;
  color: #333;
}

/deep/ .svg-funnel-js .svg-funnel-js__subLabels .svg-funnel-js__subLabel {
  color: #333;
}

.svg-funnel-js {
  flex: 1 !important;
}

.svg-funnel-js .svg-funnel-js__container {
  width: 100%;
  height: 100%;
}

.mobile-lists {
  display: none;
}

/* .dropdown-toggle {
  width: 100%;
  text-align: left;
  color: #495057;
  &:after {
    position: absolute;
    right: 8px;
    top: 18px;
  }
} */

.dashboard-filters {
  padding: 20px 6px 22px 6px;
  .form-group {
    margin-bottom: 0;
    .form-control {
      font-family: $font-family-sans-lato;
      font-size: 0.9375rem;
    }
  }
  .dropdown-toggle {
    font-family: $font-family-sans-lato;
    font-size: 0.9375rem;
  }
}

.dashboard-filters.funnel {
  padding-bottom: 20px;
}

.modal-dialog-centered {
  .modal-header {
    padding-bottom: 0;
    .modal-title {
      display: block;
      width: 100%;
      text-align: center;
    }
  }
  .modal-body {
    font-size: 14px;
    text-align: center;
  }
}

@media only screen and (max-width: 576px) {
  .mobile-settings {
    padding-left: 0;
    padding-right: 0;
    .row {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .card {
      border-radius: 0 !important;
    }
    .card-custom {
      height: 420px !important;
      min-height: 420px !important;
    }
  }
}

@media only screen and (max-width: 768px) {
  .mobile-settings {
    margin-top: 30px;
    padding-left: 0;
    padding-right: 0;
    .row {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .card {
      border-radius: 0 !important;
    }
    .card-custom {
      height: 420px !important;
      min-height: 420px !important;
    }
  }
}

@media only screen and (max-width: 1250px) {
  .mobile-settings {
    margin-top: 30px;
    padding-left: 0;
    padding-right: 0;
    .row {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .card {
      border-radius: 0 !important;
    }
    .card-custom {
      height: 420px !important;
      min-height: 420px !important;
    }
  }
}

/* @media only screen and (min-width: 1900px) {
  .graphs-container {
    position: relative;
  }

  .graphs,
  #wrapper {
    overflow: hidden;
    .card-custom {
      margin: 0 0 30px 0 !important;
      height: 520px;
    }
    .row {
      padding-left: 9px;
      padding-right: 9px;
    }
  }
  #funnel-chart {
    width: 100%;
  }
  .svg-funnel-js {
    padding-top: 160px;
    width: 100%;
  }
}

@media only screen and (max-width: 1251px) {
  #wrapper {
    .card {
      border-radius: 8px !important;
    }
    .card-custom {
      margin: 30px 0 0 0 !important;
    }
  }
}

@media only screen and (max-width: 992px) {
  #wrapper {
    .row {
      padding-left: 0;
      padding-right: 0;
    }
    .form-group {
      padding: 0 !important;
      padding-left: 30px !important;
      padding-right: 30px !important;
      margin-bottom: 12px;
    }
    .card-custom {
      margin: 25px 0 0 0 !important;
      overflow: hidden;
      border-radius: 0 !important;
    }
  }
  .col-md-6,
  .col-md-12 {
    width: 100%;
    max-width: 100%;
    flex: 100%;
    padding: 0;
    .card {
      border-radius: 0 !important;
    }
  }
  .mobile-lists {
    h6 {
      background: #fff;
      margin: 20px 0 0 0;
      padding: 12px 15px 0px 15px;
      font-size: 1.2rem;
    }
    display: block;
    width: 100%;
    .list-unstyled {
      margin-bottom: 0;
      font-family: $font-family-sans-lato;
      background: #fff;
      li {
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 15px 15px 15px;
        .user {
          display: block;
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 4px;
          text-decoration: none;
        }
        .company {
          color: #333;
          text-decoration: none;
          font-weight: 600;
          font-size: 16px;
        }
        .location,
        .job-position,
        .date,
        .rec {
          font-size: 14px;
        }
        .location {
          color: $color-orange;
        }
        .job-position {
          color: #666;
        }
        .logs {
          text-transform: uppercase;
          font-size: 12px;
          margin-right: 12px;
          font-weight: 600;
          color: #666;
        }
      }
    }
  }
  .hide-on-mobile {
    display: none !important;
  }
}

@media only screen and (max-width: 768px) {
  #wrapper {
    .row {
      padding-left: 0;
      padding-right: 0;
    }
    .form-group {
      padding: 0 !important;
      padding-left: 30px !important;
      padding-right: 30px !important;
      margin-bottom: 12px;
    }
    .card-custom {
      margin: 25px 0 0 0 !important;
      overflow: hidden;
      border-radius: 0 !important;
    }
  }
  .col-md-6,
  .col-md-12 {
    padding: 0;
    .card {
      border-radius: 0 !important;
      height: auto !important;
      min-height: auto !important;
    }
  }
  .mobile-lists {
    h6 {
      background: #fff;
      margin: 20px 0 0 0;
      padding: 12px 15px 0px 15px;
      font-size: 1.2rem;
    }
    display: block;
    width: 100%;
    .list-unstyled {
      font-family: $font-family-sans-lato;
      background: #fff;
      margin-bottom: 0;
      li {
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 15px 15px 15px;
        .user {
          display: block;
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 4px;
          text-decoration: none;
        }
        .company {
          color: #333;
          text-decoration: none;
          font-weight: 600;
          font-size: 16px;
        }
        .location,
        .job-position,
        .date,
        .rec {
          font-size: 14px;
        }
        .location {
          color: $color-orange;
        }
        .job-position {
          color: #666;
        }
        .logs {
          text-transform: uppercase;
          font-size: 12px;
          margin-right: 12px;
          font-weight: 600;
          color: #666;
        }
      }
    }
  }
  .hide-on-mobile {
    display: none !important;
  }
}

@media only screen and (max-width: 576px) {
  #wrapper {
    .row {
      padding-left: 0;
      padding-right: 0;
    }
    .form-group {
      padding: 0 !important;
      padding-left: 30px !important;
      padding-right: 30px !important;
      margin-bottom: 12px;
    }
    .card-custom {
      margin: 0 0 20px 0 !important;
      border-radius: 0 !important;
    }
  }
  .col-md-6,
  .col-md-12 {
    padding: 0;
    .card {
      border-radius: 0 !important;
    }
  }

  .hide-on-mobile {
    display: none !important;
  }

  .mobile-lists {
    h6 {
      background: #fff;
      margin: 20px 0 0 0;
      padding: 12px 15px 0px 15px;
      font-size: 1.2rem;
    }
    display: block;
    width: 100%;
    .list-unstyled {
      font-family: $font-family-sans-lato;
      background: #fff;
      li {
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 15px 15px 15px;
        .user {
          display: block;
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 4px;
          text-decoration: none;
        }
        .company {
          color: #333;
          text-decoration: none;
          font-weight: 600;
          font-size: 16px;
        }
        .location,
        .job-position,
        .date,
        .rec {
          font-size: 14px;
        }
        .location {
          color: $color-orange;
        }
        .job-position {
          color: #666;
        }
        .logs {
          text-transform: uppercase;
          font-size: 12px;
          margin-right: 12px;
          font-weight: 600;
          color: #666;
        }
      }
    }
  }
} */
</style>
